import React, { useState, useEffect } from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import Tooltip from "@mui/material/Tooltip";
import RefreshIcon from "@mui/icons-material/Refresh";
import { BASE_URL } from "../../utils/config";
import Switch from "@mui/material/Switch";
import { styled } from "@mui/material/styles";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";


const IOSSwitch = styled((props) => (
  <Switch
    focusVisibleClassName=".Mui-focusVisible"
    disableRipple
    {...props}
  />
))(({ theme }) => ({
  width: 42,
  height: 26,
  padding: 0,
  "& .MuiSwitch-switchBase": {
    padding: 0,
    margin: 2,
    transitionDuration: "300ms",
    "&.Mui-checked": {
      transform: "translateX(16px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        backgroundColor: "#23499E",
        opacity: 1,
        border: 0,
      },
    },
  },
  "& .MuiSwitch-thumb": {
    width: 22,
    height: 22,
  },
  "& .MuiSwitch-track": {
    borderRadius: 13,
    backgroundColor: "#E9E9EA",
    opacity: 1,
  },
}));


const NKBTab = ({
  Record = [],
  PreviousClose = [],
  onRefresh,
}) => {
  const navigate = useNavigate();

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);

  const [prevPage, setPrevPage] = useState(0);
  const [prevRowsPerPage, setPrevRowsPerPage] = useState(10);

  const [openDialog, setOpenDialog] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [cmp, setCmp] = useState(0);
  const [BookPorL, setBookPorL] = useState(0);

  const [checked, setChecked] = useState(true);
  const [commentrymessage, setCommentryMessage] = useState("");

const [cmpMap, setCmpMap] = useState({});
const [normalizedPrevClose, setNormalizedPrevClose] = useState([]);

useEffect(() => {
  const fetchAllCMP = async () => {
    const promises = Record
      .filter(r => r.InstrumentToken)
      .map(async (row) => {
        try {
          const token = row.InstrumentToken;
          const res = await fetch(
            `${BASE_URL}/getcmpdashboard/${token}/${token}/${token}`
          ).then(r => r.json());

          return res.success ? { id: row.id, cmp: res.data } : null;
        } catch {
          return null;
        }
      });

    const results = await Promise.all(promises);

    const updates = {};
    results.forEach(r => {
      if (r) updates[r.id] = r.cmp;
    });

    setCmpMap(updates);
  };

  if (Record.length) fetchAllCMP();
}, [Record]);

useEffect(() => {
  const normalized = PreviousClose.map(r => ({
    ...r,
    SignalDT:
      r.SignalDT ||
      (r.datetime
        ? new Date(r.datetime).toLocaleString("en-IN")
        : null),
  }));

  setNormalizedPrevClose(normalized);
}, [PreviousClose]);

useEffect(() => {
  console.log("Normalized SignalDT:", normalizedPrevClose.map(r => r.SignalDT));
}, [normalizedPrevClose]);

const calPLNKB = (row) => {
  if (
    row.EntryPrice == null ||
    row.PriceAtExit == null ||
    !row.Decision
  ) {
    return <span>-</span>;
  }

  const isBuy = row.Decision.includes("BUY");

  const plValue = isBuy
    ? row.PriceAtExit - row.EntryPrice
    : row.EntryPrice - row.PriceAtExit;

  const pl = +plValue.toFixed(2);
  const percent = +((pl / row.EntryPrice) * 100).toFixed(2);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      {/* <span>{pl}</span> */}
      <div style={{ display: "flex", alignItems: "center" }}>
        {pl >= 0 ? (
          <ArrowDropUpIcon fontSize="small" sx={{ color: "green" }} />
        ) : (
          <ArrowDropDownIcon fontSize="small" sx={{ color: "red" }} />
        )}
        <span style={{ color: pl >= 0 ? "green" : "red" }}>
          {Math.abs(pl)} ({percent}%)
        </span>
      </div>
    </div>
  );
};

const renderDecision = (value) => {
  const isBuy = typeof value === "string" && value.includes("BUY");

  return (
    <span
      style={{
        fontWeight: isBuy ? 800 : 500, // extra bold for BUY
        letterSpacing: isBuy ? "0.3px" : "normal",
      }}
    >
      {value || "-"}
    </span>
  );
};



  // Table COLUMNS
  const columns = [
    { id: "Decision", label: "DECISIONS" },
    { id: "Index", label: "Index" },
    { id: "SignalDT", label: "SignalDT" }, 
    { id: "EntryPrice", label: "Entry Price" },
    { id: "CurrentCMP", label: "CurrentCMP" },
    { id: "SL", label: "S.L" },
    { id: "HAS", label: "HAS" },
    { id: "LAS", label: "LAS" },
    { id: "HDate", label: "H. Date" },
    { id: "LDate", label: "L. Date" },
    { id: "LastCheckedDt", label: "Last Checked Dt" },
  ];

  const handleRefresh = () => {
  console.log("NKB refresh clicked (API yet to come)");
};


const hyperLinkStockName = async (row) => {
  console.log("NKB rowData", row);

  if (!row.InstrumentToken) {
    alert("Instrument token not available");
    return;
  }

  const token = row.InstrumentToken;

  try {
    const res = await fetch(
      `${BASE_URL}/getcmpdashboard/${token}/${token}/${token}`
    ).then(r => r.json());

    if (res.success) {
      const liveCmp = res.data;

      setSelectedRecord(row);
      setCmp(liveCmp);

      let pl =
        row.SignalFinal === "BUY NKB"
          ? liveCmp - row.PriceAtSignal
          : row.PriceAtSignal - liveCmp;

      setBookPorL(pl.toFixed(2));
      setOpenDialog(true);
    } else {
      alert(res.message || "CMP not found");
    }
  } catch (err) {
    console.error("NKB CMP fetch error", err);
    alert("CMP fetch failed");
  }
};


const handleDialogRefresh = async () => {
  if (!selectedRecord?.InstrumentToken) return;

  const res = await fetch(
    `${BASE_URL}/getcmpdashboard/${selectedRecord.InstrumentToken}/${selectedRecord.InstrumentToken}/${selectedRecord.InstrumentToken}`

  ).then(r => r.json());

  if (res.success) {
    const liveCmp = res.data;
    setCmp(liveCmp);

    let pl =
      selectedRecord.SignalFinal === "BUY NKB"
        ? liveCmp - selectedRecord.PriceAtSignal
        : selectedRecord.PriceAtSignal - liveCmp;

    setBookPorL(pl.toFixed(2));
  }
};


const handleBookProfitOrLoss = async () => {
  if (!selectedRecord) return;

  const body = JSON.stringify({
    BookPL: BookPorL,
    IsCommentary: checked,
    CommentryMessage: commentrymessage,
  });

  fetch(
    `${BASE_URL}/bookprofitorcloseposition?id=${selectedRecord.id}&cmpPrice=${cmp}`,
    {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body,
    }
  )
    .then((res) => res.json())
    .then((res) => {
      if (res.success) {
        setOpenDialog(false);
        setChecked(true);
        setCommentryMessage("");
        onRefresh && onRefresh();
      } else {
        alert(res.message || "Book Profit failed");
      }
    })
    .catch(err => {
      console.error("Book Profit error", err);
    });
};


const handleClose = () => {
  setOpenDialog(false);
  setChecked(true);
  setCommentryMessage("");
};

const handleChange = (event) => {
  setChecked(event.target.checked);
};


const calCurrCompNKB = (row) => {
  const cmp = cmpMap[row.id];

  // if (cmp === undefined || cmp === null) {
  //   return <span>-</span>;
  // }


   let value 
  let percentDifference

  if(row.SignalFinal === 'SELL NKB'){
  value =  row.PriceAtSignal - cmp
  value = value.toFixed(2);
  percentDifference = ((value / row.PriceAtSignal) * 100).toFixed(2);
  }
  else{
    value =   cmp - row.PriceAtSignal 
    value = value.toFixed(2);
    percentDifference = ((value / row.PriceAtSignal) * 100).toFixed(2); 
  }

  // const value = +(cmp - row.PriceAtSignal).toFixed(2);
  // const percentDifference = +(
  //   (value / row.PriceAtSignal) * 100
  // ).toFixed(2);

  return (
    // <div style={{ display: "flex", flexDirection: "column" }}>
    //   <span>{cmp}</span>
    //   <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
    //     {value >= 0 ? (
    //       <ArrowDropUpIcon fontSize="small" sx={{ color: "green" }} />
    //     ) : (
    //       <ArrowDropDownIcon fontSize="small" sx={{ color: "red" }} />
    //     )}
    //     <span style={{ color: value >= 0 ? "green" : "red" }}>
    //       {Math.abs(value)} ({percentDifference}%)
    //     </span>
    //   </div>
    // </div>

    <div style={{display:'flex',flexDirection:'column'}}>
        {row.Current_cmp === '' ? (
          <span>{row.Current_cmp}</span>
      ) : (
          <div>
              <span>{row.Current_cmp}</span>
              <div>
                  <span>
                      {value >= 0 ? <ArrowDropUpIcon fontSize="small" sx={{ color: 'green' }} /> : <ArrowDropDownIcon fontSize="small" sx={{ color: 'red' }} />}
                  </span>
                  <span style={{ color: value >= 0 ? 'green' : 'red' }}>{`${Math.abs(value)}(${percentDifference}%)`}</span>
              </div>
          </div>
    
     
      )}
        </div>
  );
};

  return (
    <div className="screenerTab">
      {/* HEADER */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          maxWidth: "1200px",
          padding: "0 20px",
          marginBottom: "12px",
        }}
      >

<h6
  style={{
    margin: 0,
    display: "flex",
    alignItems: "center",
    gap: "8px",
  }}
>
  NKB Dashboard

  <Tooltip title="Refresh Data" placement="right">
  <span
    onClick={handleRefresh}
    style={{
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      width: "36px",
      height: "36px",
      backgroundColor: "#23499E",
      borderRadius: "10px", // rounded square like image
      cursor: "pointer",
    }}
  >
    <RefreshIcon
      sx={{
        width: 18,
        height: 18,
        color: "#FFFFFF",
      }}
    />
  </span>
</Tooltip>

</h6>

        <Button
          variant="contained"
          color="primary"
          onClick={() => navigate("/addSRLevel")}
        >
          ADD LEVEL
        </Button>
      </div>

      {/* ================= MAIN TABLE ================= */}
      <Paper sx={{ width: "100%" }}>
        <TableContainer
          sx={{
            maxHeight: 420,
            overflowX: "auto", // ✅ ENABLE X SCROLL
          }}
        >
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                {columns.map((col) => (
                  <TableCell
                    key={col.id}
                    align="center"
                    sx={{
                      backgroundColor: "#23499E",
                      color: "#FFFFFF !important",
                      fontWeight: "bold",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {col.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>

            <TableBody>
              {Record
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => (
                  <TableRow hover key={row.id}>
                    
<TableCell align="center"> {renderDecision(row.SignalFinal)}</TableCell>
<TableCell align="center">
  <span
    style={{
      color: '#286bf7',
      fontWeight: 600,
      cursor: 'pointer',
      fontSize: '16px',
    }}
    onClick={() => hyperLinkStockName(row)}
  >
    {row.SignalType || "-"}
  </span>
</TableCell>

<TableCell align="center">{row.SignalDT || "-"}</TableCell>
<TableCell align="center">{row.PriceAtSignal || "-"}</TableCell>
<TableCell align="center">{calCurrCompNKB(row)}</TableCell>{/*  Current CMP –  blank for now */}
<TableCell align="center">{row.SignalStopLoss || "-"}</TableCell>
<TableCell align="center">{row.HighAfterSignal || "-"}</TableCell>
<TableCell align="center">{row.LowAfterSignal || "-"}</TableCell>
<TableCell align="center">{row.HighDT || "-"}</TableCell>
<TableCell align="center">{row.LowDT || "-"}</TableCell>
<TableCell align="center">{row.LastCheckedDT || "-"}</TableCell>
                    
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>

        <TablePagination
          rowsPerPageOptions={[25, 50, 75]}
          component="div"
          count={Record.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={(_, newPage) => setPage(newPage)}
          onRowsPerPageChange={(e) => {
            setRowsPerPage(+e.target.value);
            setPage(0);
          }}
        />
      </Paper>

{/* Book Profit / Close Position Dialog */}
<Dialog open={openDialog} onClose={handleClose}>
  <DialogTitle>
    {BookPorL >= 0 ? "BOOK PROFIT" : "BOOK LOSS"}
  </DialogTitle>

  <DialogContent style={{ width: "420px", padding: "2px 24px" }}>
    {/* Refresh */}
    <div style={{ textAlign: "center", marginBottom: 10 }}>
      <span
        onClick={handleDialogRefresh}
        style={{
          cursor: "pointer",
          color: "#23499E",
          display: "inline-flex",
          alignItems: "center",
          gap: 6,
          fontWeight: 500,
        }}
      >
        <RefreshIcon sx={{ width: 18, height: 18 }} />
        Refresh
      </span>
    </div>

    {/* Cash CMP */}
    <div style={{ textAlign: "center", marginBottom: 12 }}>
      <p style={{ marginBottom: 6 }}>Cash CMP</p>

      <input
        type="number"
        value={cmp}
        onChange={(e) => {
          const value = Number(e.target.value);
          setCmp(value);

          let pl =
            selectedRecord.SignalFinal === "BUY NKB"
              ? value - selectedRecord.PriceAtSignal
              : selectedRecord.PriceAtSignal - value;

          setBookPorL(pl.toFixed(2));
        }}
        style={{
            fontSize: 20,
            textAlign: "center",
            width: 200,
            border: "2px dotted #919090",
            borderRadius: 8,
            padding: "6px 10px",
            outline: "none",       
        }}
      />

      {/* P/L */}
      <div
        style={{
          marginTop: 8,
          fontWeight: 600,
          color: BookPorL >= 0 ? "green" : "red",
        }}
      >
        {BookPorL}
      </div>
    </div>

    {/* With Commentary toggle */}
    <div style={{ width: "100%", marginTop: 16 }}>
      <label htmlFor="withCommentery" style={{ marginRight: 10 }}>
        With Commentary
      </label>
      <IOSSwitch
        sx={{ m: 1 }}
        checked={checked}
        onChange={handleChange}
        inputProps={{ "aria-label": "controlled" }}
      />
    </div>

    {/* Commentary */}
    <div style={{ width: "100%", marginTop: 10 }}>
      <label htmlFor="Commentry">Commentary</label>
      <textarea
        id="inputField"
        placeholder="Type a message"
        value={commentrymessage}
        onChange={(e) => setCommentryMessage(e.target.value)}
        style={{
          width: "100%",
          height: 80,
          marginTop: 6,
          padding: 8,
          borderRadius: 6,
          border: "2px solid #000",
          resize: "none",
        }}
      />
    </div>
  </DialogContent>

  <DialogActions>
    <Button onClick={handleClose}>Cancel</Button>
    <Button
      onClick={(e) =>
        handleBookProfitOrLoss(
          e,
          BookPorL >= 0 ? "Book Profit" : "Close Position"
        )
      }
    >
      {BookPorL >= 0 ? "Book Profit" : "Close Position"}
    </Button>
  </DialogActions>
</Dialog>


        {/* ===================== HISTORICAL DECISIONS ===================== */}
        <h6 style={{ marginTop: "20px" }}>Historical Decisions</h6>
{console.log("PreviousClose row:", PreviousClose)}

        <Paper sx={{ width: "100%" }}>
        <TableContainer
            sx={{
            maxHeight: 320,
            overflowX: "auto", // horizontal scroll
            }}
        >
            <Table stickyHeader>
            <TableHead>
                <TableRow>
                {[
                    "DECISIONS",
                    "Index",
                    "SignalDT",
                    "Entry Price",
                    "S.L",
                    "Price at Exit",
                    "Exit Dt",
                    "P/L",
                    "HAS",
                    "LAS",
                    "H. Date",
                    "L. Date",
                    "Last Checked Dt",
                    "SL Trigger",
                ].map((head) => (
                    <TableCell
                    key={head}
                    align="center"
                    sx={{
                        backgroundColor: "#23499E",
                        color: "#FFFFFF !important",
                        fontWeight: 600,
                        whiteSpace: "nowrap",
                    }}
                    >
                    {head}
                    </TableCell>
                ))}
                </TableRow>
            </TableHead>

            <TableBody>
                {normalizedPrevClose
                .slice(
                    prevPage * prevRowsPerPage,
                    prevPage * prevRowsPerPage + prevRowsPerPage
                )
                .map((row, idx) => (
                    <TableRow key={idx}>
                    <TableCell align="center">{renderDecision(row.Decision)}</TableCell>
                    <TableCell align="center">{row.Index || "-"}</TableCell>
                    <TableCell align="center">{row.SignalDT || "-"}</TableCell>
                    <TableCell align="center">{row.EntryPrice || "-"}</TableCell>
                    <TableCell align="center">{row.SL || "-"}</TableCell>
                    <TableCell align="center">{row.PriceAtExit || "-"}</TableCell>
                    <TableCell align="center">{row.ExitDt || "-"}</TableCell>
                    <TableCell align="center">{calPLNKB(row)}</TableCell>
                    <TableCell align="center">{row.HAS || "-"}</TableCell>
                    <TableCell align="center">{row.LAS || "-"}</TableCell>
                    <TableCell align="center">{row.HDate || "-"}</TableCell>
                    <TableCell align="center">{row.LDate || "-"}</TableCell>
                    <TableCell align="center">{row.SLTrigger || "-"}</TableCell>

                    <TableCell align="center">
                        {row.LastCheckedDt || "-"}
                    </TableCell>
                    </TableRow>
                ))}
            </TableBody>
            </Table>
        </TableContainer>

        <TablePagination
            rowsPerPageOptions={[5, 10]}
            component="div"
            count={PreviousClose.length}
            rowsPerPage={prevRowsPerPage}
            page={prevPage}
            onPageChange={(_, newPage) => setPrevPage(newPage)}
            onRowsPerPageChange={(e) => {
            setPrevRowsPerPage(+e.target.value);
            setPrevPage(0);
            }}
        />
        </Paper>
      
    </div>
  );
};

export default NKBTab;
